import React from 'react';
import navbarData from "../../../data/Navbar/navbar";
import { LinkWithQuery } from '../../../helpers/LinkWithQuery';

// On the local site version, "Local Moving" leads the Services dropdown.
// Same URL-based detection convention as Titles/Footer/Skill.
const isLocalVersion = window.location.href.includes("local.navysealsmoving");
const menuItems = navbarData.map(item =>
    item.title === "Services" && isLocalVersion
        ? { ...item, subMenu: [{ title: "Local Moving", link: "/local-moving" }, ...item.subMenu] }
        : item
);

function NavbarItem(props) {
    return(
        menuItems.map(item=>(
            <li key={item.id}
                className={item.subMenu || item.megaMenu ? 'menuItemHasChildren' : ''}
            >
                <LinkWithQuery to={`${process.env.PUBLIC_URL + item.link}`}>{item.title}</LinkWithQuery>
                {(() => {
                    if(item.subMenu){
                        return(
                            <ul className="subMenu">
                                {
                                    item.subMenu.map((subItem,index)=>{
                                        return <li key={index}><LinkWithQuery to={`${process.env.PUBLIC_URL + subItem.link}`}>{subItem.title}</LinkWithQuery></li>
                                    })
                                }
                            </ul>
                        )
                    }

 
                })()}
            </li>
        ))
    )
}

export default NavbarItem